import React, {useContext, useEffect, useState} from 'react';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import styles from "./modal-content-order-reject.module.scss";
import SuccessModalContent from "../modal-content-success/modal-content-success";
import {
  ORDER_CONFIRM_ERROR,
  ORDER_REJECT_SUCCESS, ORDER_REJECTED
} from "../../../../../helpr/constants";
import ErrorModalContent from "../modal-content-error/modal-content-error";
import {
  REDUCER_ACTION_UPDATE_STATUS,
  SecurityContext,
  SecurityDispatchContext
} from "../../../../../context/security-context";
import SecurityService from "../../../../../services/security-service";
import rejectIcon from "../../../../../assets/reject-orange.svg"

const OrderRejectModalContent = ({order, onCancel, onClose, modalConfig}) => {
  const SUCCESS_TITLE = "RESERVATION REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const { setModalState } = modalConfig;
  const [ loading, setLoading] = useState(false);
  const [ page, setPage ] = useState(0);
  const { ordersState, securityState } = useContext(SecurityContext);
  const { ordersDispatch } = useContext(SecurityDispatchContext);
  const securityService = new SecurityService();

  useEffect(() => {
    setModalState(prev => {
      return {
        ...prev,
        style: `${styles['confirm-modal']}`
      }
    })
  }, [])

  const rejectOrder = async () => {
    setLoading(true);
    try {
      await securityService.rejectOrder(securityState.securityId, order.orderId);
      ordersDispatch({
        type: REDUCER_ACTION_UPDATE_STATUS,
        previous: ordersState,
        data: {
          id: order.orderId,
          value: ORDER_REJECTED
        }
      });
      setModalState(prev => {
        return {
          ...prev,
          style: `${styles['success-modal']}`
        }
      })
      setPage(1);
    } catch(error) {
      setModalState(prev => {
        return {
          ...prev,
          style: `${styles['error-modal']}`
        }
      })
      setPage(2)
    } finally {
      setLoading(false);
    }
  }

  const cancel = () => {
    setModalState(prev => {
      return {
        ...prev,
        style: `${styles['success-modal']}`
      }
    });
    onCancel()
  }

  return page === 0 ? (
    <div className={styles['reject-order']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO REJECT RESERVATION?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Reject" src={rejectIcon} />
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button variant="warning" disabled={loading} onClick={() => rejectOrder()}>
              {loading ? <Spinner size="sm" animation="border" /> : 'Yes'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={() => cancel()}>No</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : ( page === 1
    ? <SuccessModalContent title={SUCCESS_TITLE} message={ORDER_REJECT_SUCCESS} onClose={onClose}/>
    : <ErrorModalContent title={ERROR_TITLE} message={ORDER_CONFIRM_ERROR} onClose={onClose}/>)
}

export default OrderRejectModalContent;
